/*                                                */
import { noop } from '../../../shared/utils.js';
import { user_pre_effect } from '../../reactivity/effects.js';
import { on } from '../elements/events.js';

/**
 *
 *
 *
 *
 */
export function trusted(fn) {
	return function (...args) {
		var event = /*                */ (args[0]);
		if (event.isTrusted) {
			/*         */
			fn?.apply(this, args);
		}
	};
}

/**
 *
 *
 *
 *
 */
export function self(fn) {
	return function (...args) {
		var event = /*                */ (args[0]);
		/*         */
		if (event.target === this) {
			/*         */
			fn?.apply(this, args);
		}
	};
}

/**
 *
 *
 *
 *
 */
export function stopPropagation(fn) {
	return function (...args) {
		var event = /*                */ (args[0]);
		event.stopPropagation();
		/*         */
		return fn?.apply(this, args);
	};
}

/**
 *
 *
 *
 *
 */
export function once(fn) {
	var ran = false;

	return function (...args) {
		if (ran) return;
		ran = true;

		/*         */
		return fn?.apply(this, args);
	};
}

/**
 *
 *
 *
 *
 */
export function stopImmediatePropagation(fn) {
	return function (...args) {
		var event = /*                */ (args[0]);
		event.stopImmediatePropagation();
		/*         */
		return fn?.apply(this, args);
	};
}

/**
 *
 *
 *
 *
 */
export function preventDefault(fn) {
	return function (...args) {
		var event = /*                */ (args[0]);
		event.preventDefault();
		/*         */
		return fn?.apply(this, args);
	};
}

/**
 *
 *
 *
 *
 */
export function passive(node, [event, handler]) {
	user_pre_effect(() => {
		return on(node, event, handler() ?? noop, {
			passive: true
		});
	});
}

/**
 *
 *
 *
 *
 */
export function nonpassive(node, [event, handler]) {
	user_pre_effect(() => {
		return on(node, event, handler() ?? noop, {
			passive: false
		});
	});
}
